import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../constants';
import { OauthAEMConfig } from '../../../models';
import {
  SubmitActivationPayload,
  SubmitSmsOtp
} from '../../../models/multi-factor-authentication.interfaces';
import { UtilService } from '../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class SubmitSMSActivationService {
  submitSmsActivationHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.activateSmsDevice+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  SubmitSMSActivation = (
    authConfig: OauthAEMConfig,
    flowIdValue: string,
    otp: string
  ): Observable<SubmitSmsOtp> => {
    const getSubmitSmsActivation = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const submitSmsActivationUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getSubmitSmsActivation
      }
    ];

    const payload: SubmitActivationPayload = {
      otp: otp
    };

    return new ApiBuilder<SubmitActivationPayload, SubmitSmsOtp>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(submitSmsActivationUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .payload(payload)
      .httpHeaders(this.submitSmsActivationHeader)
      .errorHandler(this._errorHandler)
      .library('SUBMIT_SMS_Activation_Service')
      .withCredentials(true)
      .create();
  };
}
